const Pouches = () => {
	return <h1>Pouches</h1>;
  };
  
  export default Pouches;